import { sampleStatusList, departementList } from 'json/lab-order'
// [LAB]

export let filterFactor = [{
  label: '委托方',
  slotName: 'clientOrganizationId' // 需返回数据的字段名
}, {
  label: '检测项目',
  slotName: 'labExamItemId'
}, {
  label: '检测依据',
  slotName: 'examBasis'
}, {
  label: '样品名称',
  type: 'input',
  clearable: true,
  placeholder: '请输入样品名称',
  value: 'orderName' // 需返回数据的字段名
}, {
  label: '实验人员',
  slotName: 'experimenter'

}, {
  label: '待操作状态',
  type: 'select',
  clearable: true,
  value: 'orderStatusEnum',
  options: sampleStatusList
}, {
  label: '开始时间',
  type: 'date',
  clearable: true,
  value: 'createdDateStart' // 需返回数据的字段名
}, {
  label: '结束时间',
  type: 'date',
  clearable: true,
  value: 'createdDateEnd' // 需返回数据的字段名
}, {
  label: '是否加急',
  type: 'select',
  clearable: true,
  value: 'urgent', // 需返回数据的字段名
  options: [{
    label: '是',
    value: 'true'
  }, {
    label: '否',
    value: 'false'
  }]
}, {
  label: '是否偏离',
  type: 'select',
  clearable: true,
  value: 'deviate', // 需返回数据的字段名
  options: [{
    label: '是',
    value: 'true'
  }, {
    label: '否',
    value: 'false'
  }]
}, {
  label: '是否返还',
  type: 'select',
  clearable: true,
  value: 'back', // 需返回数据的字段名
  options: [{
    label: '是',
    value: 'true'
  }, {
    label: '否',
    value: 'false'
  }]
}, {
  label: '所属科室',
  type: 'select',
  clearable: true,
  allowCreate: true,
  value: 'departmentName', // 需返回数据的字段名
  options: [...departementList, {
    value: '无',
    label: '无'
  }]
  },
  {
    label: "生产批号",
    type: 'input',
    clearable: true,
    value: 'productBatchCode',
    placeholder: '请输入生产批号'
  }
]
export const filterFactor_some = [{
  label: '检测项目',
  slotName: 'labExamItemId'
}, {
  label: '检测依据',
  slotName: 'examBasis'
}, {
  label: '样品名称',
  type: 'input',
  clearable: true,
  value: 'orderName',
  placeholder: '请输入样品名称'
}, {
  label: '待操作状态',
  type: 'select',
  clearable: true,
  value: 'orderStatusEnum',
  options: sampleStatusList
}, {
  label: '实验人员',
  slotName: 'experimenter'
}, {
  label: '开始时间',
  type: 'date',
  clearable: true,
  value: 'createdDateStart'
}, {
  label: '结束时间',
  type: 'date',
  clearable: true,
  value: 'createdDateEnd'
}, {
  label: '所属科室',
  type: 'select',
  clearable: true,
  allowCreate: true,
  value: 'departmentName', // 需返回数据的字段名
  options: [...departementList, {
    value: '无',
    label: '无'
  }]
}]
export let tabs = [{
    label: '全部样品',
    value: 'ALL'
  },
  ...sampleStatusList
]

export const tableLabels = [{
    label: '样品编号',
    value: 'orderCode',
    minWidth: '170px'
  },
  {
    label: "客户标识",
    value: "customerCode",
    minWidth: '150px'
  },
  {
    label: "生产批号",
    value: 'productBatchCode',
    minWidth: '120px'
  },
  {
    label: '实验室唯一码',
    value: 'labCode',
    minWidth: '120px'
  },
  {
    label: '所属委托单编号',
    value: 'billCode',
    minWidth: '150px'
  },
  {
    label: '所属科室',
    value: 'departmentName',
    minWidth: '120px'
  },
  {
    label: '检测项目',
    value: 'labExamItem.itemName',
    minWidth: '120px'
  },
  {
    label: '检测依据',
    value: 'labExamItem.examBasis.name',
    minWidth: '120px'
  },
  {
    label: '是否偏离',
    value: 'deviate_text',
    minWidth: '120px'
  },
  {
    label: '样品名称',
    value: 'orderName',
    minWidth: '120px'
  },
  {
    label: "交付方式",
    value: "delivery_type"
  },
  // {
  //   label: '数量',
  //   value: 'orderCount',
  //   minWidth: '120px'
  // },
  {
    label: '颜色',
    value: 'color_text',
    minWidth: '120px'
  },
  {
    label: '形态',
    value: 'shape_text',
    minWidth: '120px'
  },

  {
    label: '包装',
    value: 'pack_text',
    minWidth: '120px'
  },
  {
    label: '存放条件',
    value: 'storage_text',
    minWidth: '120px'
  },
  {
    label: '预计交付日期',
    value: 'delivery_date',
    minWidth: '120px'
  },
  {
    label: '实验人员',
    value: 'experimenter_show',
    minWidth: '120px'
  },
  {
    label: '状态',
    slotName: 'orderStatus',
    minWidth: '120px'
  },
  {
    label: '最近更新时间',
    value: 'last_modified_date',
    minWidth: '120px'
  },
  {
    label: "指标数量",
    value: "orderCount"
  },
  {
    label: '操作',
    slotName: 'operate',
    fixed: 'right',
    minWidth: '120px'
  }
]